export default __webpack_public_path__ + "static/media/Group 194.0dbd4aee.png";